import homeplate from '../../style/images/bg_homeplate.png'
import homeplate2 from '../../style/images/base.png'
import zoneborder from '../../style/images/red_border.png'
import field from '../../style/images/bg_hitter_line.png'
import zone from '../../style/images/277415.png'

export const SpeedOptions = {
  aspectRatio: 0.9,
  layout: {
    padding: {
      top: 40, right: -300
    }
  },
  elements: {
    point: {
      pointRadius: 0,
      //pointBackgroundColor:'rgb(0, 0, 0)',
      //pointBorderColor:'rgb(0, 0, 0)',                        
    },
    line: {
      borderWidth: 2,
      tension: 0.4,
      fill: true,
    }
  },
  responsive: true,
  plugins: {
    legend: false,
    tooltip: false,
  },
  scales: {
    x: {
      type: "linear",
      min: 100,
      max: 165,
      ticks: {
        stepSize: 5, display: true,
        callback: function (val, index) {
          // Hide every 2nd tick label
          return val >= 110 && val < 165 && index % 2 === 0 ? this.getLabelForValue(val) : "";
        },
      },
      title: {
        display: true,
        text: 'KPH',
        align: 'end',
      },
      grid: {
        drawBorder: false,
        color: function (context) {
          if (context.tick.value >= 110 && context.tick.value < 165)
            return '#EEEEEE';
          else
            return '#EEEEEE00';
        },
      },
    },
    y0: {
      type: 'category',
      position: 'left',
      stack: 'type',
      ticks: { display: true, labelOffset: -20, crossAlign: 'near', padding: 0, mirror: false, z: 10, },
      labels: [["   　AVG", "%  KPH"]],
    },
    r1: {
      type: 'category',
      position: 'right',
      display: true,
      offset: false,
      stack: 'right',
      ticks: { display: true, mirror: true, align: "end" },
      labels: [20 + "%", "0%"],
      title: { display: false },
      grid: {
        drawBorder: false,
        borderWidth: 0,
        drawOnChartArea: false
      },
    },
  }
}

export const SpinDirectionOptions = {
  hoverBorderWidth:0,
  onHover:null,
  responsive: true,    
  aspectRatio:0.9,               
  plugins: {
    legend: false,
    tooltip: false,
  },
  scales: {
    r: {      
      startAngle:0, 
      ticks: {display:false},                 
      pointLabels: {                          
      display: true,
      centerPointLabels: false,
      font: {
        size: 14
        }
      },
      grid: {
        display: false,
      },
      angleLines: {
        display: true,
        color: '#CCCCCC'
      },
    },                   
  }
}

export const MovementOptions = {
  responsive: true,
  aspectRatio: 0.9,
  plugins: {
    legend: {
      display: true,
      position: 'bottom',
    },
    tooltip: false,
  },
  elements: {
    point: {
      pointRadius: 5,
    },
  },
  scales: {
    x: {
      min: -25,
      max: 25,
      ticks: { display: true, stepSize: 5, },
      title: {
        display: true,
        text: "水平位移",
        font: {
          size: 14
        }
      },
      grid: {
        drawTicks: false,
        tickWidth: 0,
        drawBorder: false,
        borderWidth: 0,
      },
    },
    y: {
      min: -25,
      max: 25,
      ticks: { display: true, stepSize: 5, },
      title: {
        display: true,
        text: "垂直位移",
        font: {
          size: 14
        }
      },
      grid: {
        drawTicks: false,
        tickWidth: 0,
        drawBorder: false,
        borderWidth: 0,
      },
    },
  }
}

let image = new Image()
image.src = homeplate
export const ReleasePointConfig = {
  plugins: [{
    id: 'custom_canvas_background_image',
    beforeDraw: (chart) => {
      if (image.complete) {
        const ctx = chart.ctx;
        const { top, left, width, height } = chart.chartArea;
        
        var image_rwd_width = window.innerWidth * image.width * 1.65 / 1920;
        var image_rwd_height = window.innerWidth * image.height * 1.65 / 1920;
        const x = left + width / 2 - image_rwd_width / 2;
        const y = top + height;
        ctx.drawImage(image, x, y, image_rwd_width, image_rwd_height);
      } else {
        image.onload = () => chart.draw();
      }
    }
  }],
  options: {
    responsive: true,
    aspectRatio: 1.05,
    layout: {
      padding: {
        bottom: 100,
      },
    },
    legend: {
      position: 'left',
      display: false
    },
    plugins: {
      legend: {
        display: false,
        position: 'bottom',
      },
      tooltip: false,
    },
    elements: {
      point: {
        pointRadius: 2,
      },
    },
    scales: {
      x: {
        min: -135,
        max: 135,
        ticks: { display: false, stepSize: 20, },
        grid: {
          display: false,
          borderWidth: 0
        },
      },
      y: {
        min: 0,
        max: 200,
        ticks: {
          display: true, stepSize: 20,
          callback: function (val, index) {
            return (val <= 180 || val >= 0) && index%2===0 ? val + " cm" : "";
          }
        },
        grid: {
          display: true,
        },
      },
    }
  }
}

export const ReleaseHeightTrendOptions = {
  aspectRatio: 1.1,
  responsive: true,
  legend: {
    position: 'left',
    display: false
  },
  plugins: {
    legend: {
      display: false,
      position: 'chartArea',
    },
    tooltip: false,
  },
  elements: {
    point: {
      pointRadius: 4,
    },
    line: {
      borderWidth: 2,
    }
  },
  scales: {
    x: {
      type: "linear",
      min: 0,
      suggestMax: 50,
      ticks: {
        stepSize: 1, display: true,
        callback: function (val, index) {
          return val === 0 ? "" : val;
        }
      },
      title: {
        display: true,
        text: 'Pitch',
        align: 'end',
      },
      grid: {
        drawTicks: false,
        tickWidth: 0,
        drawBorder: true,
        borderWidth: 1,
        borderDash: [2, 2]
      },
    },
    y: {
      suggestMin: 0,
      suggestMax: 200,
      ticks: {
        display: true,
        stepSize: 5,
        callback: function (val, index) {
          return (val <= 180 || val >= 0)? val + " cm":""
        }
      },
      grid: {
        drawTicks: false,
        drawBorder: true,
        tickWidth: 0,
        borderWidth: 1,
        borderDash: [2, 2]
      },
    },
  }
}

export const SpinTrendOptions = {
  aspectRatio: 1.1,
  responsive: true,
  legend: {
    position: 'left',
    display: false
  },
  plugins: {
    legend: {
      display: false,
      position: 'chartArea',
    },
    tooltip: false,
  },
  elements: {
    point: {
      pointRadius: 4,
    },
    line: {
      borderWidth: 2,
    }
  },
  scales: {
    x: {
      type: "linear",
      min: 0,
      suggestMax: 15,
      ticks: {
        stepSize: 1, display: true,
        callback: function (val, index) {
          return val === 0 ? "" : val;
        }
      },
      title: {
        display: true,
        text: 'Pitch',
        align: 'end',
      },
      grid: {
        drawTicks: false,
        tickWidth: 0,
        drawBorder: true,
        borderWidth: 1,
        borderDash: [2, 2]
      },
    },
    y: {
      suggestMin: 1000,
      suggestMax: 3200,
      ticks: {
        display: true,
        stepSize: 50,
        callback: function (val, index) {
          return (val <= 3200 || val >= 1000)? val + " R":""
        }
      },
      grid: {
        drawTicks: false,
        drawBorder: true,
        tickWidth: 0,
        borderWidth: 1,
        borderDash: [2, 2]
      },
    },
  }
}

export const MovementTrendOptions = {
  aspectRatio: 1.1,
  responsive: true,
  legend: {
    position: 'left',
    display: false
  },
  plugins: {
    legend: {
      display: false,
      position: 'chartArea',
    },
    tooltip: false,
  },
  elements: {
    point: {
      pointRadius: 4,
    },
    line: {
      borderWidth: 2,
    }
  },
  scales: {
    x: {
      type: "linear",
      min: 0,
      suggestMax: 15,
      ticks: {
        stepSize: 1, display: true,
        callback: function (val, index) {
          return val === 0 ? "" : val;
        }
      },
      title: {
        display: true,
        text: 'Pitch',
        align: 'end',
      },
      grid: {
        drawTicks: false,
        tickWidth: 0,
        drawBorder: true,
        borderWidth: 1,
        borderDash: [2, 2]
      },
    },
    y: {
      suggestMin: -40,
      suggestMax: 40,
      ticks: {
        display: true,
        stepSize: 5,
        callback: function (val, index) {
          return (val <= 40 || val >= -40)? val:""
        }
      },
      grid: {
        drawTicks: false,
        drawBorder: true,
        tickWidth: 0,
        borderWidth: 1,
        borderDash: [2, 2]
      },
    },
  }
}

let plateImage = new Image(), borderImage = new Image()
plateImage.src = homeplate2
borderImage.src = zoneborder
export const KZoneConfig = {
  plugins: [
    {
      id: 'custom_canvas_base_image',
      beforeDraw: (chart) => {
        if (plateImage.complete) {
          const ctx = chart.ctx;
          const { top, left, width, height } = chart.chartArea;
          var image_rwd_width = window.innerWidth * plateImage.width / 1920;
          var image_rwd_height = window.innerWidth * plateImage.height / 1920;
          const x = left + width / 2 - image_rwd_width / 2;
          const y = top + height - image_rwd_height - (21.5 * window.innerWidth / 1920);
          ctx.drawImage(plateImage, x, y, image_rwd_width, image_rwd_height);
        } else {
          plateImage.onload = () => chart.draw();
        }
      }
    },
    {
      id: 'custom_canvas_red_border_image',
      beforeDraw: (chart) => {
        if (borderImage.complete) {
          const ctx = chart.ctx;
          const {top, left, width, height} = chart.chartArea;
          var image_rwd_width= window.innerWidth * borderImage.width/1920;
          var image_rwd_height= window.innerWidth * borderImage.height/1920;
          const x = left + width / 2 - image_rwd_width / 2;
          const y = top + height /2 - image_rwd_height / 2 ;
          ctx.drawImage(borderImage, x, y,image_rwd_width,image_rwd_height);
        } else {
          borderImage.onload = () => chart.draw();
        }
      }
    }
  ],
  options: {
    responsive: true,  
    aspectRatio: 0.95,
    layout: {
      padding: {
        bottom: 60,
      },
    },
    legend: {
      position: 'left',
      display: false
    },
    plugins: {
      legend: false,
      tooltip: false,
    },
    elements: {
      point: {
        pointRadius: 4,
      },
    },
    scales: {
      x: {
        min: -50,
        max: 50,
        ticks: { display: false, stepSize: 5, },
        grid: {
          display: false,
          drawTicks: false,
          borderWidth: 0
        },
      },
      y: {
        min: -10,
        max: 70,
        ticks: { display: false, stepSize: 5 },
        grid: {
          display: false,
          drawTicks: false,
          borderWidth: 0
        },
      },
    } 
  }
}

/*
{
  id: 'custom_canvas_base_image',
  beforeDraw: (chart) => {
    if (plateImage.complete) {
      const ctx = chart.ctx;
      const { top, left, width, height } = chart.chartArea;
      var image_rwd_width = window.innerWidth * 1.8 * plateImage.width / 1920;
      var image_rwd_height = window.innerWidth * 1.8 * plateImage.height / 1920;
      const x = left + width / 2 - image_rwd_width / 2;
      const y = top + height - image_rwd_height - (42 * window.innerWidth / 1920);
      ctx.drawImage(plateImage, x, y, image_rwd_width, image_rwd_height);
    } else {
      plateImage.onload = () => chart.draw();
    }
  }
},
{
  id: 'custom_canvas_red_border_image',
  beforeDraw: (chart) => {
    if (borderImage.complete) {
      const ctx = chart.ctx;
      const {top, left, width, height} = chart.chartArea;
      var image_rwd_width= window.innerWidth * 1.8 * borderImage.width/1920;
      var image_rwd_height= window.innerWidth * 1.8 * borderImage.height/1920;
      const x = left + width / 2 - image_rwd_width / 2;
      const y = top + height /2 - image_rwd_height / 2 ;
      ctx.drawImage(borderImage, x, y,image_rwd_width,image_rwd_height);
    } else {
      borderImage.onload = () => chart.draw();
    }
  }
}
*/
let zoneImage = new Image()
zoneImage.src = zone
export const KZoneConfig2 = {
  plugins: [
    {
      id: 'custom_canvas_zone_image',
      beforeDraw: (chart) => {
        if (zoneImage.complete) {
          const ctx = chart.ctx;
          const { top, left, width, height } = chart.chartArea;
          var image_rwd_width = window.innerWidth * zoneImage.width / 1920 / 6.4;
          var image_rwd_height = window.innerWidth * zoneImage.height / 1920 / 6.6;
          const x = left + width / 2 - image_rwd_width / 2;
          const y = top + height - image_rwd_height - (16 * window.innerWidth / 1920);
          ctx.drawImage(zoneImage, x, y, image_rwd_width, image_rwd_height);
        } else {
          zoneImage.onload = () => chart.draw();
        }
      }
    },
  ],
  options: {
    responsive: true,  
    aspectRatio: 1,
    maintainAspectRatio: true,
    layout: {
      padding: {
        left: 50,
        bottom: 20,
      },
    },
    legend: {
      position: 'left',
      display: false
    },
    plugins: {
      legend: {
        display: true,
        position: 'bottom',
      },
      tooltip: false,
    },
    elements: {
      point: {
        pointRadius: 4,
      },
    },
    scales: {
      x: {
        min: -40,
        max: 40,
        ticks: { display: false, stepSize: 5, },
        grid: {
          display: false,
          drawTicks: false,
          borderWidth: 0
        },
      },
      y: {
        min: -10,
        max: 70,
        ticks: { display: false, stepSize: 5 },
        grid: {
          display: false,
          drawTicks: false,
          borderWidth: 0
        },
      },
    } 
  }
}

let fieldImage = new Image()
fieldImage.src = field
export const FieldConfig = {
  plugins: [
    {
      id: 'custom_canvas_hitter_line_image',
      beforeDraw: (chart) => {
        if (fieldImage.complete) {
          const ctx = chart.ctx;
          const { top, left, width, height } = chart.chartArea;
          var image_rwd_width = window.width * fieldImage.width / 1920;
          var image_rwd_height = window.width * fieldImage.height / 1920;
          const x = left;
          const y = top;
          ctx.drawImage(fieldImage, x, y, width, height);
        } else {
          fieldImage.onload = () => chart.draw();
        }
      }
    }
  ], 
  options: {
    responsive: true,
    aspectRatio: 0.95,
    layout: {
      padding: {
        bottom: 60,
      },
    },
    legend: {
      position: 'left',
      display: false
    },
    plugins: {
      legend: false,
      tooltip: false,
    },
    elements: {
      point: {
        pointRadius: 3,
      },
    },
    scales: {
      x: {
        min: -400,
        max: 400,
        ticks: { display: false, stepSize: 100, },
        grid: {
          display: true,
          drawTicks: false,
          borderWidth: 0
        },
      },
      y: {
        min: -100,
        max: 500,
        ticks: { display: false, stepSize: 100 },
        grid: {
          display: true,
          drawTicks: false,
          borderWidth: 0
        },
      },
    }
  },
}